import React, { useEffect, useState } from 'react';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { AccessTime } from '@mui/icons-material';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SettingsIcon from '@mui/icons-material/Settings';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useLocation, useNavigate } from 'react-router';
import { styled } from '@mui/material/styles';
import { Box, List } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';

const SidebarWrapperCollapsed = styled(Box)(
  ({ theme }) => `
              width: 50px;
              color: ${theme.sidebar.textColor};
              background: #232C68;
              box-shadow: ${theme.sidebar.boxShadow};
              height: 100%;
              
              @media (min-width: 1024px) {
                  position: fixed;
                  z-index: 10;
                  border-top-right-radius: ${theme.general.borderRadius};
                  border-bottom-right-radius: ${theme.general.borderRadius};
              }
      `
);

const TopSection = styled(Box)(
  ({ theme }) => `
          display: flex;
          height: 60px;
          justify-content: center;
          align-items: center;
  `
);

const CollapsedSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const appUser = useSelector((state: RootStateType) => state.appReducer?.user);

  const [sidebarList, setSideBarList] = useState([]);

  useEffect(() => {
    setSideBarList([
      {
        name: 'Dashboard',
        comp: (
          <DashboardIcon
            key='Dashboard'
            onClick={() => navigate('/dashboard')}
            sx={{
              mb: 3,
              mt: 2,
              color: `${
                location.pathname === '/dashboard'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Segments',
        comp: (
          <AccountBalanceWalletIcon
            key='Segments'
            onClick={() => navigate('/segments')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/segments'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Customers',
        comp: (
          <PeopleAltIcon
            key='Customers'
            onClick={() => navigate('/customers')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/customers'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Stakeholders',
        comp: (
          <SupervisorAccountIcon
            key='Stakeholders'
            onClick={() => navigate('/stakeholders')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/stakeholders'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Project',
        comp: (
          <BusinessCenterIcon
            key='Project'
            onClick={() => navigate('/project-details')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/project-details'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Employees',
        comp: (
          <RecentActorsIcon
            key='Employees'
            onClick={() => navigate('/employees')}
            sx={{
              mb: 3,
              mt: 2,
              color: `${
                location.pathname === '/employees'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Resource Pool',
        comp: (
          <ScreenSearchDesktopIcon
            key='Resource Pool'
            onClick={() => navigate('/resource-pool')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/resource-pool'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      // {
      //   name: 'Skills',
      //   comp: (
      //     <EmojiObjectsIcon
      //       onClick={() => navigate('/skills')}
      //       sx={{
      //         mb: 3,
      //         mt: 2,
      //         color: `${
      //           location.pathname === '/skills' ? 'white' : 'rgb(153, 158, 187)'
      //         }`,
      //         cursor: 'Pointer'
      //       }}
      //     />
      //   )
      // },
      // {
      //   name: 'Project Health Summary',
      //   comp: (
      //     <PendingActionsIcon
      //       onClick={() => navigate('/project-health')}
      //       sx={{
      //         mb: 3,
      //         mt: 2,
      //         color: `${
      //           location.pathname === '/project-health'
      //             ? 'white'
      //             : 'rgb(153, 158, 187)'
      //         }`,
      //         cursor: 'Pointer'
      //       }}
      //     />
      //   )
      // },
      {
        name: 'Resource Management',
        comp: (
          <ScreenSearchDesktopIcon
            key='Resource Management'
            onClick={() => navigate('/resource-management')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/resource-management'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Role Management',
        comp: (
          <ContactMailIcon
            key='Role Management'
            onClick={() => navigate('/role-management')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/role-management'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      },
      {
        name: 'Year Plan',
        comp: (
          <AccessTime
              onClick={() => navigate('/year-plan')}
              sx={{
                mb: 3,
                color: `${
                  location.pathname === '/year-plan'
                    ? 'white'
                    : 'rgb(153, 158, 187)'
                }`,
                cursor: 'Pointer'
              }}
            />
        )
      },
      {
        name: 'Configurations',
        comp: (
          <SettingsIcon
            key='Configurations'
            onClick={() => navigate('/configurations')}
            sx={{
              mb: 3,
              color: `${
                location.pathname === '/configurations'
                  ? 'white'
                  : 'rgb(153, 158, 187)'
              }`,
              cursor: 'Pointer'
            }}
          />
        )
      }
    ]);
  }, [location]);

  const [filteredSideBarItems, setFilteredSideBarItems] = useState([]);

  useEffect(() => {
    const correctOrder = [
      'Dashboard',
      'Segments',
      'Customers',
      'Stakeholders',
      'Project',
      'Project Health Summary',
      'Employees',
      'Skills',
      'Resource Management',
      'Leave Management',
      'Admin Configurations',
      'Company Configuration',
    ];

    const allClaims = appUser?.Claims?.split(',').map((val) => {
      if (val === 'Customer') {
        return 'Customers';
      } else if (val === 'Stakeholder') {
        return 'Stakeholders';
      } else if (val === 'Employee') {
        return 'Employees';
      } else {
        return val;
      }
    });

    if (appUser?.Roles.split(',').includes('Super User')) {
      allClaims.push('Role Management');
    }

    let filterArr: any = [];

    allClaims?.forEach((item) => {
      var x = sidebarList?.filter((ele) => item === ele?.name);
      if (x.length > 0 && x !== undefined) {
        filterArr.push(x[0]);
      }
    });

    let sorted: any = [];

    correctOrder.forEach((k) => {
      let n = filterArr.filter((obj) => {
        return obj.name === k;
      });
      if (n.length > 0) {
        sorted.push(n[0]);
      }
    });
    setFilteredSideBarItems(sorted);
  }, [appUser, sidebarList]);

  return (
    <SidebarWrapperCollapsed>
      <Scrollbars autoHide>
        <TopSection>
          <h1
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/dashboard')}
          >
            D
          </h1>
        </TopSection>
        <List>
          {filteredSideBarItems?.length > 0 &&
            filteredSideBarItems.map((barItem) => barItem.comp)}
        </List>
      </Scrollbars>
    </SidebarWrapperCollapsed>
  );
};

export default CollapsedSidebar;
